<script setup>
import { computed } from 'vue'
import VueApexCharts from 'vue3-apexcharts'
const props = defineProps({
  yData:{
    type: Object,
    required: true
  }
})

/** 고정 카테고리/색 */
const categories = ['목', '화', '토', '금', '수']
const barColors = {
  목: 'rgba(var(--v-theme-fiveColor03), 1)',
  화: 'rgba(var(--v-theme-fiveColor01), 1)',
  토: 'rgba(var(--v-theme-fiveColor05), 1)',
  금: 'rgba(var(--v-theme-fiveColor04), 1)',
  수: 'rgba(var(--v-theme-fiveColor02), 1)',
}

const five = computed(() => props.yData?.분석상세?.용희활용?.용희원소 ?? {})

/** 막대 값: 전체오행분포 */
const countsByElem = computed(() => five.value?.전체통계?.오행분포 ?? {})

/** 용신/희신 오행별 분포 및 공통 천간/지지 */
const ysDist = computed(() => five.value?.용신?.오행분포 ?? {})
const hsDist = computed(() => five.value?.희신?.오행분포 ?? {})
const ysInfo = computed(() => ({
  cheongan: five.value?.용신?.천간 ?? '-', // 백엔드 수정에 따라 수정 필요
  jiji: five.value?.용신?.지지 ?? '-', // 백엔드 수정에 따라 수정 필요
}))
const hsInfo = computed(() => ({
  cheongan: five.value?.희신?.천간 ?? '-',
  jiji:     five.value?.희신?.지지 ?? '-',
}))

/** 라벨 색상 배열 */
const xLabelColors = computed(() => categories.map(k => barColors[k]))

const series = computed(() => {
  const data = categories.map((key) => ({
    x: key,
    y: Number(countsByElem.value?.[key] ?? 0),
    fillColor: barColors[key],
    meta: {
      key,
      yongsin: {
        count: Number(ysDist.value?.[key] ?? 0),
        cheongan: ysInfo.value.cheongan,
        jiji: ysInfo.value.jiji,
      },
      heesin: {
        count: Number(hsDist.value?.[key] ?? 0),
        cheongan: hsInfo.value.cheongan,
        jiji: hsInfo.value.jiji,
      },
      total: Number(countsByElem.value?.[key] ?? 0),
    },
  }))
  return [{ name: '오행분포', type: 'bar', data }]
})

const chartOptions = computed(() => ({
  chart: {
    type: 'bar',
    toolbar: { show: false },
    zoom: { enabled: false },
    parentHeightOffset: 0,
  },
  plotOptions: {
    bar: {
      borderRadius: 6,
      columnWidth: '40px',
      dataLabels: { position: 'top' },
    },
  },
  dataLabels: { enabled: false },
  colors: ['transparent'],
  xaxis: {
    type: 'category',
    categories,
    tickPlacement: 'on',
    axisTicks: { show: false },
    axisBorder: { show: false },
    labels: {
      offsetY: 4,
      style: {
        colors: xLabelColors.value,
        fontFamily: 'Pretendard',
        fontSize: '14px',
        fontWeight: 700,
      },
    },
  },
  yaxis: {
    min: 0,
    tickAmount: 4,
    labels: { padding: 8, formatter: (v) => Math.round(v) },
  },
  grid: {
    padding: { top: 8, bottom: 14, left: 0, right: 0 },
  },
  tooltip: {
    custom: ({ dataPointIndex, w }) => {
      const dp = w.config.series[0].data[dataPointIndex]
      if (!dp) return ''
      const key = dp.meta?.key ?? categories[dataPointIndex]

      const raw = five.value?.[key]?.상세 ?? []
      const items = Array.isArray(raw)
        ? raw
        : String(raw ?? '').split(/\s*,\s*/).filter(Boolean)

      const total = dp.meta?.total ?? dp.y

      return `
        <div class="yh-five_tt">
          <div class="tt-row"><b>천간/지지:</b></div>
          <ul class="tt-sub-list">
            ${items.map(s => `<li>${s}</li>`).join('')}
          </ul>
          <div class="tt-total">총계: ${total}개</div>
        </div>`
    },
  },
  legend: { show: false },
  stroke: { width: 0 },
}))
// 임시저장
        // <div class="tt-title" style="color:${barColors[key]}">${key}(오행)</div>
        // <div class="tt-row"><b>용신:</b> ${ys.count ?? 0}개</div>
        // <div class="tt-sub">천간: ${ys.cheongan ?? '-'}, 지지: ${ys.jiji ?? '-'}</div>
        // <div class="tt-row"><b>희신:</b> ${hs.count ?? 0}개</div>
        // <div class="tt-sub">천간: ${hs.cheongan ?? '-'}, 지지: ${hs.jiji ?? '-'}</div>
</script>

<template>
  <div class="yh-five-chart__wrap">
    <VueApexCharts type="bar"  height="300" :options="chartOptions" :series="series" />
    <div class="yonghee-badges" v-if="yBadge || hBadge">
      <div class="yh-badge" v-if="yBadge">
        <span class="dot" :style="dotStyle(yBadge.elem)"></span>
        <span class="label">용신:</span>
        <span class="elem">{{ yBadge.elem }} ({{ yBadge.hanja }})</span>
        <div class="sub">({{ (yBadge.zones?.length || 0) }}개 구간: {{ (yBadge.zones || []).join(', ') }})</div>
      </div>

      <div class="yh-badge" v-if="hBadge">
        <span class="dot" :style="dotStyle(hBadge.elem)"></span>
        <span class="label">희신:</span>
        <span class="elem">{{ hBadge.elem }} ({{ hBadge.hanja }})</span>
        <div class="sub">({{ (hBadge.zones?.length || 0) }}개 구간: {{ (hBadge.zones || []).join(', ') }})</div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
